"use client";

import { useClientFeatureFlag as useClientFeatureFlagBase } from "@nimble/react-trackers/use-client-feature-flag";

export const FEATURE_FLAGS = [
  "savedschools",
  "applicationslist",
  "jobalerts",
  "new_application_flow",
  "district_job_board_m1",
  "district_non_teaching_tab",
] as const;

type FeatureFlag = (typeof FEATURE_FLAGS)[number];

export function useClientFeatureFlag(flag: FeatureFlag): boolean {
  return useClientFeatureFlagBase(flag);
}
